import { useTranslation } from "react-i18next";
import { getTotalMedalCount } from "../../data/medalsRepository.js";
import { getTotalTitleCount } from "../../data/titlesRepository.js";

import { useState, useEffect } from "react";

function MedagliereGenerale() {
  const { t } = useTranslation();
  const [totalMedalCount, setTotalMedalCount] = useState({
    Oro: 0,
    Argento: 0,
    Bronzo: 0,
  });
  const [totalTitlesCount, setTotalTitlesCount] = useState(0);

  useEffect(() => {
    getTotalMedalCount().then((data) => {
      setTotalMedalCount(data);
    });
    getTotalTitleCount().then((data) => {
      setTotalTitlesCount(data);
    });
  }, []);

  return (
    <div className="">
      <div className="">
        <div className="medagliere-grid">
          <h3 className="medagliere-card-title medagliere-card mb-1 col-span-3">
            {t("medagliere.nationalTitles")}
          </h3>
          <div className="medagliere-card fa-4x medal-national-title col-span-3">
            <span className="inline-flex items-center text-center gap-3 col-span-3">
              <i className="fas fa-trophy"></i>
              <span className="font-goldman-bold">{totalTitlesCount ?? 0}</span>
            </span>
          </div>
        </div>
      </div>

      <div className="medagliere-grid">
        {[
          {
            className: "medal-gold",
            number: totalMedalCount.Oro ?? 0,
            title: t("medagliere.goldMedals"),
            desc: t("medagliere.goldMedalsDescription"),
          },
          {
            className: "medal-silver",
            number: totalMedalCount.Argento ?? 0,
            title: t("medagliere.silverMedals"),
            desc: t("medagliere.silverMedalsDescription"),
          },
          {
            className: "medal-bronze",
            number: totalMedalCount.Bronzo ?? 0,
            title: t("medagliere.bronzeMedals"),
            desc: t("medagliere.bronzeMedalsDescription"),
          },
        ].map((med, idx) => (
          <div
            key={idx}
            className={`medagliere-card col-span-2 md:col-span-2 fa-2x ${med.className}`}
          >
            <div className="">
              <span className="inline-flex items-center gap-3">
                <i className="fas fa-medal"></i>
                <span className="font-goldman-bold">{med.number}</span>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MedagliereGenerale;
